module.exports = __webpack_public_path__ + "static/media/arrow_howitworks.c52f5f7c.svg";